import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TSubmitOrderPaymentRequest } from "./submitOrderPayment.schema";

export const submitOrderPayment =
  (axios: IAxiosInstance) => async (body: TSubmitOrderPaymentRequest) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      "/api/orders/payment",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
